import commonPostTypeConfig from '../../common/postTypes/partner'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'partner',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
